import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

/**
 * Renders a profile photo (or initials fallback). When `clickable` is true it
 * shows a ring indicator and emits `activate` on click/keyboard activation —
 * used to gate "view public profile" affordances to corp members who opted in.
 */
@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input() photoUrl?: string | null
  @Input() entity: any
  @Input() clickable = false
  /** Renders a square avatar (e.g. for admin/announcement senders) instead of the default circular one. */
  @Input() square = false
  /**
   * False takes it out of the Tab order (it still works with a click or tap) - for when something
   * next to it does the same, like the sender's name on a chat message, so keyboard users don't
   * stop twice for one action.
   */
  @Input() tabbable = true

  @Output() activate = new EventEmitter<void>()

  onClick(): void {
    if (this.clickable) this.activate.emit()
  }
}
